import { Card } from '@/components/ui/card.component';
import { Skeleton } from '@/components/ui/skeleton.component';
import { EntityProceduresSkeleton } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedures-skeleton.component';
import { cn } from '@/utils/cn-tw-merge';

export function ProfessionalSchedulesLoading({ className }: { className?: string }) {
  return (
    <Card className={cn('mt-4 flex w-full min-w-0 flex-1 flex-col gap-4 px-6 py-6 xl:mt-0 xl:max-w-[32rem]', className)}>
      <Skeleton className="h-7 w-52 self-center" />
      <Skeleton className="h-11 w-full" />

      <EntityProceduresSkeleton />
    </Card>
  );
}
